import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TributacaoListarModule } from "./tributacao-listar/tributacao-listar.module";
import { TributacaoEditarModule } from "./tributacao-editar/tributacao-editar.module";
import { TributacaoInserirModule } from "./tributacao-inserir/tributacao-inserir.module";

@NgModule({
    imports: [
        CommonModule,
        TributacaoEditarModule,
        TributacaoInserirModule,
        TributacaoListarModule
    ],
    exports: [
        TributacaoEditarModule,
        TributacaoInserirModule,
        TributacaoListarModule
    ]
})
export class TributacaoAppModule { }
